export default __webpack_public_path__ + "static/iPhoneFrameFullMedium-a98360b450203f296c7e436e4a8dda51.png";